import React from "react";
import { Link } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";
import BackToTop from "../components/BackToTop";
import "../css/OurOdysseyPage.css";

const OurOdysseyPage = () => {
  return (
    <>
      <Header />

      <section id="our-odyssey-banner">
        <div className="banner-slide">
          <img
            src="/wp-content/uploads/2016/07/our-odyssey-1.png"
            alt="Our Odyssey"
          />
          <div className="banner-caption">
            <h2>
              Colombo Dockyard's Graving Dock No. 01 <br />
              during construction stages in early 1900's
            </h2>
          </div>
        </div>
      </section>

      <div className="our-odyssey-wrapper">
        <div className="center-container">
          <div className="breadcrumbs">
            <Link to="/">Home</Link> &gt; <span>Our Odyssey</span>
          </div>

          <h1 className="page-title" data-aos="fade-right">
            Our Odyssey
          </h1>

          {/* Row 1: text left, image right */}
          <div className="two-column-row">
            <div className="col-text" data-aos="fade-right">
              <p>
                The shipping industry's evolution is one of constant
                transformation and innovation, quality and expectation, safety
                and environmental concerns. All of these varied dynamics are an
                everyday occurrence for Colombo Dockyard and continues to remain
                so as we etch our historical journey, 'from here to the world'.
              </p>
              <p>
                Established in 1974, Colombo Dockyard is Sri Lanka's leading
                ship repair, shipbuilding, heavy engineering and offshore
                engineering facility. Conveniently located within the port of
                Colombo, the hub of all major shipping lanes connecting the
                West, the Middle East, the Far East, as well as Africa and
                Australia, Colombo Dockyard has a strategic advantage to conduct
                both dry dock and afloat operations. Colombo Dockyard, as a
                state of the art engineering entity, operates four graving dry
                docks with a maximum capacity of 125,000 DWT and extensive
                repair berth facilities.
              </p>
            </div>
            <div className="col-image slanted-right">
              <div data-aos="fade-left">
                <img
                  src="/wp-content/uploads/2016/01/DOCK-NO1.png"
                  alt="Dock No. 1"
                />
              </div>
            </div>
          </div>

          <div className="full-text" data-aos="fade-up">
            <p>
              Colombo Dockyard, in existence for over three decades, continues
              to keep its eyes on the horizon, pre-empting trends and preparing
              for transformation. While the Company remains relatively small in
              size compared to competitors in the Asian region, our
              differentiation lies in the way we do business.
            </p>
          </div>

          {/* Row 2: image left, text right */}
          <div className="two-column-row">
            <div className="col-image slanted-left">
              <div data-aos="fade-right">
                <img
                  src="/wp-content/uploads/2016/01/our-odyssey.jpg"
                  alt="Our Odyssey"
                />
              </div>
            </div>
            <div className="col-text" data-aos="fade-left">
              <p>
                Five core values that have helped Colombo Dockyard in its
                odyssey,
              </p>
              <ul>
                <li data-aos="fade-right" data-aos-delay="100">Flexibility</li>
                <li data-aos="fade-right" data-aos-delay="150">Innovation</li>
                <li data-aos="fade-right" data-aos-delay="200">Being customer centric</li>
                <li data-aos="fade-right" data-aos-delay="250">Environment friendly</li>
                <li data-aos="fade-right" data-aos-delay="300">People focused</li>
              </ul>
              <p>
                Colombo Dockyard's niche position in building some of the
                world's most unique vessels holds the Company in good stead. The
                emphasis on absolute quality and the infusion of green
                initiatives (some of them, pioneering features in this region)
                as well as our processes, give us a competitive stance that are
                far ahead of those established in the South Asian region.
              </p>
            </div>
          </div>

          <div className="full-text" data-aos="fade-up">
            <p>
              This has resulted in improving our capabilities of effecting
              difficult and sometimes unique processes, building techniques and
              repairs, that have helped us carve out our own special position in
              this industry.
            </p>
          </div>
        </div>
      </div>

      <Footer />
      <BackToTop />
    </>
  );
};

export default OurOdysseyPage;